export default "__VITE_ASSET__CqU5Nv19__"